<!--
 * @Description: 首页
 * @Author: xiell
 * @Date: 2023-12-05 18:31:07
 * @LastEditors: kecraft
 * @LastEditTime: 2024-08-23 10:44:27
 * @FilePath: /custom-website-desk/src/views/home/index.vue
-->
<template>
  <div class="home">
    <!-- 轮播图 -->
    <div class="centerbox1" id="carousel">
      <!-- <bannerVideo></bannerVideo> -->
      <video
        v-if="itemVideoList.length > 0"
        ref="videoRefs"
        muted
        autoplay
        loop
      >
        <source :src="itemVideoList[0].imgEntireUrl" type="video/mp4" />
        您的浏览器不支持Video标签。
      </video>
    </div>
    <!-- 集团概述 -->
    <div class="jtOverview">
      <el-carousel
        v-if="itemImgeList.length > 0"
        :motion-blur="itemImgeList.length !== 1"
        style="width: 100%; height: 857px"
        class="banner_box"
        ref="bannerBox"
      >
        <el-carousel-item
          v-for="(item, index) in itemImgeList"
          :key="'videos' + index"
          style="width: 100%; height: 857px"
        >
          <img
            style="width: 100%; height: 857px"
            :src="item.imgEntireUrl"
            alt=""
          />
        </el-carousel-item>
      </el-carousel>
      <div class="textBox">
        <p class="title">集团概述</p>
        <div class="jtgsBox" v-html="normalizeRichText(jtgsText)"></div>
        <div
          class="moreBtn"
          @click="turnTo({ url: '/groupOverview', query: { chooseKey: 1 } })"
        >
          <span>查看更多</span>
          <img src="@/assets/home/moreicon.png" alt="" />
        </div>
      </div>
    </div>
    <!-- 数字栏：接口没返回数据时整块不渲染，否则会留下 230px 的空白条 -->
    <div
      class="infoList"
      id="numberBox"
      ref="numberBox"
      v-if="infoList.length > 0"
    >
      <div v-for="(ele, index) of infoList" :key="index">
        <!-- <img :src="require(`@/assets/home/listicon${index}.png`)" alt=""> -->
        <img :src="ele.icon" alt="" />
        <div>
          <p>
            <span>{{ ele.number }}</span
            >{{ ele.unit }}
          </p>
          <span>{{ ele.title }}</span>
        </div>
      </div>
    </div>
    <!-- 新闻要闻 -->
    <div class="news">
      <img src="@/assets/home/newBg.png" alt="" />
      <div class="main">
        <div class="left">
          <div class="top">
            <div class="newsTitle">集团要闻</div>
            <div class="newsContent">
              <div class="newsCarousel">
                <el-carousel
                  v-if="newsCarouselList.length > 0"
                  height="100%"
                  arrow="never"
                  :autoplay="true"
                >
                  <el-carousel-item
                    v-for="(item, index) in newsCarouselList"
                    :key="index + item.id"
                    @click="
                      item.link
                        ? turnToPage(item)
                        : turnTo({
                            url: '/newsCenter',
                            query: {
                              id: 1,
                              title: item.title,
                              content: item.id,
                            },
                          })
                    "
                  >
                    <div class="carouselItem">
                      <img
                        :src="
                          item.thumbUrl ||
                          require(`@/assets/text/default${index}.jpg`)
                        "
                        style="width: 100%; height: auto"
                        @error="handleImageError"
                      />
                      <p :title="item.title">{{ item.title }}</p>
                      <span>{{ item.timeline }}</span>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
              <div class="newsList">
                <section
                  class="newsMoreBtn"
                  @click="turnTo({ url: '/newsCenter', query: { id: 1 } })"
                >
                  查看更多<span>></span>
                </section>
                <div
                  v-for="(ele, index) of newsList"
                  :key="index"
                  @click="
                    ele.link
                      ? turnToPage(ele)
                      : turnTo({
                          url: '/newsCenter',
                          query: {
                            id: 1,
                            title: ele.title,
                            content: ele.id,
                          },
                        })
                  "
                >
                  <div>
                    <p :title="ele.title">{{ ele.title }}</p>
                    <span>{{ ele.timeline }}</span>
                  </div>
                  <img
                    :src="
                      ele.thumbUrl ||
                      require(`@/assets/text/default${index}.jpg`)
                    "
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="bottom">
            <div style="width: 48%">
              <div class="newsTitle">成员动态</div>
              <section
                class="newsMoreBtn"
                @click="turnTo({ url: '/newsCenter', query: { id: 2 } })"
              >
                查看更多<span>></span>
              </section>
              <ul>
                <li
                  v-for="(ele, index) of cydtList"
                  :key="index"
                  @click="
                    ele.link
                      ? turnToPage(ele)
                      : turnTo({
                          url: '/newsCenter',
                          query: {
                            id: 2,
                            title: ele.title,
                            content: ele.id,
                          },
                        })
                  "
                >
                  <span></span>
                  <p :title="ele.title">{{ ele.title }}</p>
                  <div class="lineUnd"></div>
                  <div>
                    {{ ele.timeline.substring(0, 10) }}
                  </div>
                </li>
              </ul>
            </div>
            <div>
              <div class="newsTitle">信息公开</div>
              <section
                class="newsMoreBtn"
                @click="turnTo({ url: '/informationOpen', query: { id: 1 } })"
              >
                查看更多<span>></span>
              </section>
              <ul>
                <li
                  v-for="(ele, index) of xxgkList"
                  :key="index"
                  @click="
                    ele.link
                      ? turnToPage(ele)
                      : turnTo({
                          url: '/informationOpen',
                          query: { id: 1, title: ele.title, content: ele.id },
                        })
                  "
                >
                  <span></span>
                  <p :title="ele.title">{{ ele.title }}</p>
                  <div class="lineUnd"></div>
                  <div>
                    {{ ele.timeline.substring(0, 10) }}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="right">
          <!-- 单位在模块内滚动即可看全，不再需要“查看更多”入口 -->
          <div class="unitTitle">
            <div class="newsTitle">成员单位</div>
          </div>
          <el-scrollbar
            style="
              width: 100%;
              height: 100%;
              border-radius: 10px;
              border: 1px solid #e6e6e6;
            "
            wrap-style="overflow-y:auto;"
            always
          >
            <div class="list">
              <div
                :style="{
                  background: `url(${ele.bgImg}) no-repeat center/100% 100%`,
                  'border-radius': '10px',
                  cursor: 'pointer',
                }"
                v-for="(ele, index) of unitsList"
                :key="index + 'img_bg'"
                @click="turnToPage(ele)"
              >
                <p v-html="ele.name"></p>
              </div>
            </div>
          </el-scrollbar>
        </div>
        <!-- <div class="plateTitle">
          <div class="newsTitle">板块业务</div>
          <section
            class="newsMoreBtn"
            @click="turnTo({ url: '/blockBusiness', query: { id: 126 } })"
          >
            查看更多<span>></span>
          </section>
        </div> -->
      </div>
    </div>

    <!-- 板块业务 -->
    <div
      class="bkywBox"
      :class="
        bkywIndex === 0
          ? 'bkywBg0'
          : bkywIndex === 1
          ? 'bkywBg1'
          : bkywIndex === 2
          ? 'bkywBg2'
          : bkywIndex === 3
          ? 'bkywBg3'
          : bkywIndex === 4
          ? 'bkywBg4'
          : bkywIndex === 5
          ? 'bkywBg5'
          : bkywIndex === 6
          ? 'bkywBg6'
          : ''
      "
    >
      <!-- <div
        class="totalBox"
        :class="bkywIndex === -1 ? 'blueBg' : ''"
        @mouseenter="() => (bkywIndex = -1)"
        @mouseleave="() => (bkywIndex = -2)"
      >
        <p>板块业务</p>
        <div @click="turnTo({ url: '/blockBusiness', query: { id: 126 } })">
          <span>查看更多</span>
          <img src="@/assets/home/moreicon2.png" alt="" />
        </div>
      </div> -->
      <div
        :class="bkywIndex === index ? 'blueBg' : ''"
        v-for="(ele, index) of bkywList"
        :key="index"
        @mouseenter="() => (bkywIndex = index)"
        @mouseleave="() => (bkywIndex = -2)"
      >
        <p>{{ ele.title }}</p>
        <div class="content" v-html="normalizeRichText(ele.content)"></div>
        <div
          class="moreBox"
          @click="
            turnTo({ url: '/blockBusiness', query: { id: ele.resourceId } })
          "
        >
          <span>了解更多</span>
          <img
            :class="bkywIndex === index ? 'moveImg' : ''"
            src="@/assets/home/jt.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <!-- 企业文化 + 专题专栏 整块按要求隐藏 -->
    <!-- <div class="infoBox">
      <div class="sameBox">
        <section class="infoTitle">企业文化</section>
        <section
          class="newsMoreBtn"
          @click="turnTo({ url: '/enterpriseCulture', query: { id: 2 } })"
        >
          查看更多<span>></span>
        </section>
        <ul>
          <li
            v-for="(ele, index) of qywhList"
            :key="index"
            @mouseenter="changeqywhIndex(index)"
            @click="
              ele.link
                ? turnToPage(ele)
                : turnTo({
                    url: '/enterpriseCulture',
                    query: {
                      id: 2,
                      title: ele.title,
                      content: ele.id,
                    },
                  })
            "
          >
            <div class="smallBox" v-if="qywhIndex !== index">
              <p>{{ ele.title }}</p>
              <span>{{ ele.timeline.substring(0, 10) }}</span>
            </div>
            <div v-if="qywhIndex === index" class="bigBox">
              <img
                :src="
                  ele.thumbUrl || require(`@/assets/text/default${index}.jpg`)
                "
                alt=""
              />
              <div>
                <span>{{ ele.timeline }}</span>
                <p>{{ ele.title }}</p>
                <img src="@/assets/home/jt.png" alt="" />
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div>
        <section class="infoTitle">专题专栏</section>
        <el-scrollbar
          style="
            width: 100%;
            height: 100%;
            border-radius: 10px;
            border: 1px solid #e6e6e6;
          "
          wrap-style="overflow-y:auto;"
        >
          <div class="cardBox" v-for="(ele, index) of ztzlList" :key="index">
            <div class="imgBox">
              <img :src="ele.thumbUrl" alt="" />
            </div>
            <div class="wordBox">
              <p :title="ele.title">{{ ele.title }}</p>
              <div
                @click="
                  turnTo({
                    url: '/featureColumn',
                    query: { id: ele.id },
                  })
                "
              >
                查看<span>></span>
              </div>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div> -->
    <!-- 公司地址 -->
    <div class="addressBox">
      <div class="worldBox">
        <section class="title">{{ lxwmInfor.title }}</section>
        <p>地址：{{ lxwmInfor.address }}</p>
        <p>邮编：{{ lxwmInfor.zipcode }}</p>
        <p>电话：{{ lxwmInfor.tel }}</p>
        <p>传真： {{ lxwmInfor.fax }}</p>
        <p>E-mail：{{ lxwmInfor.email }}</p>
      </div>
      <div class="mapBox">
        <img :src="mapImage" alt="地图" class="map-image" />
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, reactive, nextTick, watch } from "vue";
import bannerVideo from "./components/banner.vue";
import { StarFilled } from "@element-plus/icons-vue";
import mapImage from "@/assets/home/map-placeholder.jpg";
import { useRouter } from "vue-router";
import api from "@/api/api";
import { normalizeRichText } from "@/utils/richText";
import moment from "moment";
import emitter from "@/utils/mitt";
const itemImgeList = ref([]);
const itemVideoList = ref([]);
const getRandomNumber = () => {
  const numbers = [1, 2, 3, 4, 5];
  const randomIndex = Math.floor(Math.random() * numbers.length);
  return require(`@/assets/text/default${numbers[randomIndex]}.jpg`);
};
const router = useRouter();
const carouselHeight = ref("1072px");
const doSomething = (entries, observer) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      if (infoList.value.length > 0) {
        nextTick(() => {
          infoList.value[0] && animateNumber(infoList.value[0].number, 0);
          infoList.value[1] && animateNumber(infoList.value[1].number, 1);
          infoList.value[2] && animateNumber(infoList.value[2].number, 2);
          infoList.value[3] && animateNumber(infoList.value[3].number, 3);
        });
      }
    }
  });
};

const options = {
  root: null, // 相对于浏览器视窗
  rootMargin: "0px",
  threshold: 0.1, // 至少10%的元素可见时触发
};

const turnTo = (data) => {
  router.push({
    path: data.url,
    query: data.query,
  });
};
const turnToPage = (data) => {
  if (data.link) {
    window.open(data.link, "_blank");
  }
};
const turnDetailPage = (data) => {
  emitter.emit("turnDetailPage", data);
  router.push({
    path: "/informationOpen",
    query: { id: 1 },
  });
};

const jtgsText = ref("");
const getJtgsText = () => {
  const resourceId = 74;
  api.getPageConfigDetail(resourceId).then((res) => {
    if (res.code === "0" && res.res.data) {
      jtgsText.value = res.res.data.content;
    }
  });
};
const infoList = ref([]);
const getInfoList = () => {
  const resourceId = 77;
  api.getSzInfoList({ resourceId }).then((res) => {
    if (res.code === "0" && res.res.data) {
      let arr = res.res.data.slice(0, 4) || [];
      arr.forEach((ele) => {
        ele.number = ele.number * 1;
      });
      infoList.value = arr;
    }
  });
};
const handleImageError = (event) => {
  event.target.src = getRandomNumber();
};
const newsCarouselList = ref([]);
const newsList = ref([]);
const getNewsCarouselList = () => {
  let obj = {
    resourceId: 68,
    classifyId: 1,
    pageSize: 7,
    pageNo: 1,
  };
  api.getArticleList(obj).then((res) => {
    if (res.code === "0" && res.res.data) {
      let arr = res.res.data.records;
      newsCarouselList.value = arr.slice(0, 3);
      newsList.value = arr.slice(3, 7);
    }
  });
};
const cydtList = ref([]);
const getCydtList = () => {
  let obj = {
    resourceId: 68,
    classifyId: 2,
    pageSize: 7,
    pageNo: 1,
  };
  api.getArticleList(obj).then((res) => {
    if (res.code === "0" && res.res.data) {
      let arr = res.res.data.records.slice(0, 7) || [];
      cydtList.value = arr;
    }
  });
};
const animateNumber = (target, index) => {
  let current = 0;
  const increment = (target - current) / (2000 / 12);
  const interval = setInterval(() => {
    current += increment;
    if (current >= target) {
      current = target;
      clearInterval(interval);
    }
    infoList.value[index].number = Math.ceil(current);
  });
};
const setHeight = () => {
  let dom = document.getElementsByClassName("centerbox1")[0];
  if (dom) {
    let w = dom.offsetWidth;
    let h = Math.ceil((1072 / 1920) * w);
    carouselHeight.value = h + "px";
  }
};
const getItemImgeList = () => {
  api.getBannerList().then((res) => {
    if (res.code === "0" && res.res.data) {
      let arr = res.res.data.map((item) => ({
        ...item,
        isVideo:
          item.imgEntireUrl.indexOf(".mp4") > 0 ||
          item.imgEntireUrl.indexOf(".mov") > 0,
      }));
      itemImgeList.value = arr.filter((item) => !item.isVideo);
      itemVideoList.value = arr.filter((item) => item.isVideo);
    } else {
      itemImgeList.value = [];
      itemVideoList.value = [];
    }
  });
};
const observer = new IntersectionObserver(doSomething, options);
// 数字栏无数据时不渲染，元素要等接口回来才出现，所以在 watch 里挂观察者（数字滚动动画靠它触发）
watch(
  () => infoList.value.length,
  async () => {
    await nextTick();
    const numberBox = document.getElementById("numberBox");
    if (numberBox) {
      observer.observe(numberBox);
    }
  },
  { immediate: true }
);
onMounted(() => {
  // setHeight();
  getItemImgeList();
  window.addEventListener("resize", () => {
    setHeight();
  });
  getJtgsText();
  getInfoList();
  getNewsCarouselList();
  getCydtList();
  getUnitsList();
  getBkywList();
  getQywhList();
  getXxgkList();
  getlxwmInfor();
  getZtzlList();
});

const unitsList = ref([]);
const getUnitsList = () => {
  api.getMemberUnitList().then((res) => {
    if (res.code === "0" && res.res.data) {
      // 接口无分页参数、一次返回全量，这里不再截断：容器高度固定，
      // 单位多于 6 行时行距保持不变，多出来的部分由模块内滚动查看
      let arr = res.res.data || [];
      arr.forEach((ele) => {
        let index = Math.ceil(ele.title.length / 2);
        let str1 = ele.title.slice(0, index);
        let str2 = ele.title.slice(index);
        ele.name = str1 + "<br/>" + str2;
      });
      unitsList.value = arr;
    }
  });
};
const ztzlList = ref([]);
const getZtzlList = () => {
  let obj = {
    resourceId: 21,
    specialId: 0,
  };
  api.getZtzlList(obj).then((res) => {
    if (res.code === "0" && res.res.data) {
      let arr = res.res.data;
      ztzlList.value = arr;
    }
  });
};
const qywhList = ref([]);
const getQywhList = () => {
  let obj = {
    resourceId: 68,
    classifyId: 5,
    pageSize: 6,
    pageNo: 1,
  };
  api.getArticleList(obj).then((res) => {
    if (res.code === "0" && res.res.data) {
      let arr = res.res.data.records;
      qywhList.value = arr.slice(0, 6);
    }
  });
};
const qywhIndex = ref(0);
const changeqywhIndex = (val) => {
  if (qywhIndex.value === val) {
    return;
  }
  qywhIndex.value = val;
};
const xxgkList = ref([]);
const getXxgkList = () => {
  let obj = {
    resourceId: 52,
    ctypeId: "15,16",
    pageSize: 7,
    pageNo: 1,
  };
  api.getArticleList(obj).then((res) => {
    if (res.code === "0" && res.res.data) {
      let arr = res.res.data.records;
      xxgkList.value = arr.slice(0, 7);
    }
  });
};
const bkywList = ref([
  {
    title: "新能源板块",
    resourceId: 126,
    content: "",
  },
  {
    title: "航空航天复材制造板块",
    resourceId: 129,
    content: "",
  },
  {
    title: "海洋船舶及相关制造",
    resourceId: 159,
    content: "",
  },
  {
    title: "其他装备制造板块",
    resourceId: 169,
    content: "",
  },
  {
    title: "工美文化",
    resourceId: 164,
    content: "",
  },
  {
    title: "军工板块",
    resourceId: 135,
    content: "",
  },
  {
    title: "民爆板块",
    resourceId: 132,
    content: "",
  },
  {
    title: "产业服务板块",
    resourceId: 174,
    content: "",
  },
]);
const getBkywList = () => {
  bkywList.value.forEach((ele) => {
    api.getPageConfigDetail(ele.resourceId).then((res) => {
      if (res.code === "0" && res.res.data) {
        let obj = res.res.data;
        // ele.title = obj.title
        ele.content = obj.content;
        ele.id = obj.id;
      }
    });
  });
};
const bkywIndex = ref(-2);
const lxwmInfor = ref({});
const getlxwmInfor = () => {
  const resourceId = 69;
  api.getPageConfigDetail(resourceId).then((res) => {
    if (res.code === "0" && res.res.data) {
      lxwmInfor.value = res.res.data;
    }
  });
};
</script>
<style scoped lang="less">
.lineUnd {
  position: absolute !important;
  width: 100% !important;
  height: 1px !important;
  bottom: -12px;
  background-color: #e5e7f6;
}

.map-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.home {
  width: 100%;
  background: #ffffff;
}

.centerbox1 {
  height: 900px;
  video {
    width: 100%;
    height: 900px;
    object-fit: cover;
  }
}

:deep(.centerbox1 .el-carousel__button) {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.5);
  opacity: 1;
}

:deep(.el-scrollbar__view) {
  height: 100% !important;
}

:deep(.centerbox1 .is-active .el-carousel__button) {
  background: #009fe8;
}

:deep(.centerbox1 .el-carousel__indicator--horizontal) {
  width: 20px;
  height: 20px;
  border: 1px solid transparent;
  border-radius: 50%;
  padding: 4px;
  box-sizing: border-box;
}

:deep(.centerbox1 .el-carousel__indicators--horizontal .is-active) {
  border: 1px solid #009fe8;
}

:deep(
    .centerbox1
      .el-carousel__indicators--horizontal
      .el-carousel__indicator--horizontal:not(:last-child)
  ) {
  margin-right: 8px;
}

:deep(.centerbox1 .el-carousel__indicators--horizontal) {
  bottom: 70px;
}

.jtOverview {
  width: 100%;
  height: 857px;
  position: relative;
  // img {
  //   width: 100%;
  //   display: block;
  // }
}

.textBox {
  position: absolute;
  left: 13.61vw;
  top: 50%;
  transform: translateY(-50%);
  width: 38.54%;
  height: 80%;
  background: url("~@/assets/home/jtgs.png") no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;

  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 1.98vw;
    color: #242b3c;
    line-height: 4.41vh;
    text-align: left;
    font-style: normal;
    position: absolute;
    left: 12%;
    top: 16%;
  }

  .jtgsBox {
    width: 75%;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    // font-size: 18px;
    font-size: 0.9375vw;
    color: #1e2b47;
    line-height: 2.15;
    // line-height: 43px;
    text-align: justify;
    font-style: normal;
    position: absolute;
    left: 12%;
    top: 29%;

    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
  }

  .moreBtn {
    width: 10.42vw;
    height: 3.125vw;
    background: #006ab1;
    border-radius: 32px;
    position: absolute;
    left: 12%;
    bottom: 17%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 12px 0 25px;
    cursor: pointer;
    transition: transform 0.3s ease;

    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 0.83vw;
      color: #ffffff;
      line-height: 1.97vh;
      text-align: center;
      font-style: normal;
    }

    img {
      width: 2.08vw;
      height: 2.08vw;
      cursor: pointer;
    }
  }

  .moreBtn:hover {
    transform: scale(1.1);
  }
}

.infoList {
  width: 100%;
  height: 230px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 9% 0 10%;

  & > div {
    display: flex;
    align-items: center;

    img {
      margin-right: 15px;
      height: 55px;
    }

    & > div {
      p {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 18px;
        color: #333333;
        line-height: 28px;
        text-align: justify;
        font-style: normal;

        span {
          font-family: DINAlternate, DINAlternate;
          font-weight: bold;
          font-size: 46px;
          color: #333333;
          line-height: 66px;
          text-align: justify;
          font-style: normal;
          margin-right: 15px;
        }
      }

      & > span {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 18px;
        color: #333333;
        line-height: 28px;
        text-align: justify;
        font-style: normal;
        margin-top: 8px;
      }
    }
  }
}

.news {
  width: 100%;
  height: 975px;
  overflow: hidden;
  position: relative;

  img {
    width: 100%;
    height: 1060px;
    display: block;
  }

  .main {
    width: 100%;
    height: 1060px;
    padding: 2.717% 8.33% 0 8.33%;
    position: absolute;
    left: 0%;
    top: 0%;
    display: flex;
    box-sizing: border-box;

    // justify-content: space-between;
    .left {
      width: calc(100% - 453px);
      height: 83.93%;
      margin-right: 35px;
      display: flex;
      flex-direction: column;

      .top {
        width: 100%;
        height: 50.12%;
        display: flex;
        flex-direction: column;
        margin-bottom: 39px;

        .newsContent {
          width: 100%;
          height: calc(100% - 89px);
          display: flex;
          align-items: center;
          justify-content: space-between;

          & > div {
            width: 48.57%;
            height: 100%;
          }

          .newsCarousel {
            cursor: pointer;
            margin-left: 5px;
            width: 48.57%;
            height: 100%;
            background: #222;
            border-radius: 8px;

            :deep(.el-carousel) {
              height: 100%;
              border-radius: 8px;
            }

            :deep(.el-carousel__indicators--horizontal) {
              right: 10px;
              left: auto;
              transform: translateX(0);
            }

            :deep(.el-carousel__button) {
              width: 25px;
            }

            :deep(.is-active .el-carousel__button) {
              background: #0088e9;
            }

            .carouselItem {
              width: 100%;
              height: 100%;
              position: relative;

              p {
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: 16px;
                color: #ffffff;
                text-align: left;
                font-style: normal;
                position: absolute;
                left: 15px;
                bottom: 38px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 90%;
              }

              span {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #ffffff;
                text-align: left;
                font-style: normal;
                position: absolute;
                left: 15px;
                bottom: 13px;
              }
            }
          }
        }
      }

      .bottom {
        width: 100%;
        height: 45.27%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        & > div {
          width: 49%;
          height: 100%;
          box-sizing: border-box;
          // padding-top: 20px;
          position: relative;

          & > .newsMoreBtn {
            position: absolute;
            right: 5px;
            top: 28px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 18px;
            color: #97a3c2;
            text-align: left;
            font-style: normal;
            display: flex;
            align-items: center;
            cursor: pointer;

            span {
              font-size: 12px;
              margin-left: 5px;
            }
          }

          ul {
            width: 100%;
            height: calc(100% - 89px);
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            li {
              position: relative;
              display: flex;
              align-items: center;
              width: 100%;
              cursor: pointer;
              flex: 1;
              min-height: 0;
              margin-bottom: 0;

              span {
                width: 5px;
                height: 5px;
                background: #009fe8;
                border-radius: 50%;
                flex-shrink: 0;
              }

              p {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 18px;
                color: #333333;
                text-align: left;
                font-style: normal;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: calc(100% - 126px);
                box-sizing: border-box;
                padding: 0 10px;
              }

              div {
                position: absolute;
                right: 0px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 13px;
                color: #999999;
                text-align: left;
                font-style: normal;
                width: 80px;
                flex-shrink: 0;
              }

              .lineUnd {
                bottom: 0;
              }
            }
          }
        }
      }
    }

    .right {
      width: 418px;
      height: 83.93%;
      display: flex;
      flex-direction: column;

      .list {
        width: 100%;
        // height: calc(100% - 92px);
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        // 首行贴容器上边、末行贴容器下边，行间距等分
        align-content: space-between;
        // 行距固定为“6 行卡片刚好铺满容器”时的间距：(容器高 - 6 × 86px) / 5，再留 1px 余量，
        // 免得亚像素取整让刚好铺满时冒出一条多余的滚动条。
        // 单位 ≤ 12（6 行）时，space-between 会把这 5px 余量再等分回去，行距与改动前一致；
        // 超过 6 行、内容溢出后 space-between 退化成 flex-start，行距仍按这个值保持，
        // 不会塌成上下紧贴，多出来的单位由外层 el-scrollbar 滚动查看。
        row-gap: calc((100% - 516px) / 5 - 1px);
        flex-wrap: wrap;

        div {
          // width: 48%;
          // height: 8.53%;
          width: 204px;
          height: 86px;
          // 下外边距会顶起末行、让它贴不到底边，行间距统一交给 .list 分配
          // margin-bottom: 10px;
          // background: url("~@/assets/home/unitsBg.png") no-repeat;
          // background-size: 100% 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          p {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: #ffffff;
            line-height: 25px;
            text-shadow: 0px 1px 3px rgba(16, 16, 39, 0.5);
            text-align: center;
            font-style: normal;
          }
        }
      }
    }

    .plateTitle {
      width: 83.34%;
      height: 15%;
      position: absolute;
      bottom: 0px;
      left: 8.33%;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;

      .newsMoreBtn {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 18px;
        color: #97a3c2;
        text-align: left;
        font-style: normal;
        display: flex;
        align-items: center;
        cursor: pointer;
        margin-bottom: 22px;
      }
    }
  }
}

.newsTitle {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 38px;
  color: #242b3c;
  line-height: 67px;
  height: 67px;
  text-align: left;
  margin-bottom: 22px;
}

// 成员单位标题行（单位变多时可在模块内滚动查看，不再放“查看更多”）
.unitTitle {
  margin-bottom: 15px;

  .newsTitle {
    margin-bottom: 0;
  }
}

.newsList {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;

  & > div {
    width: 100%;
    height: 20%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    cursor: pointer;

    img {
      width: 17.86%;
      height: 86.09%;
      border-radius: 8px;
    }

    div {
      width: 71.964%;
      height: 100%;
      display: flex;
      flex-direction: column;
      // justify-content: space-between;
      box-sizing: border-box;
      padding-left: 15px;
      position: relative;

      p {
        height: 28px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 18px;
        color: #333333;
        // line-height: 1.57vh;
        line-height: 28px;
        height: 28px;
        text-align: left;
        font-style: normal;
        overflow: hidden;
        /* 确保内容超出容器时会被裁剪 */
        display: -webkit-box;
        /* 使用弹性盒子布局模型 */
        -webkit-line-clamp: 1;
        /* 限制在2行 */
        -webkit-box-orient: vertical;
        /* 垂直排列盒子 */
        text-overflow: ellipsis;
        /* 多行时显示省略符号 */
        white-space: normal;
        /* 使用正常的白空格处理方式，允许换行 */
      }

      span {
        margin-top: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        line-height: 20px;
        text-align: left;
        font-style: normal;
      }
    }

    div::after {
      content: "";
      width: 5px;
      height: 5px;
      background: #009fe8;
      border-radius: 50%;
      position: absolute;
      left: -2px;
      top: 11px;
    }
  }

  & > div:not(:last-child)::after {
    content: "";
    width: 100%;
    height: 1px;
    background: #e5e7f6;
    border-radius: 50%;
    position: absolute;
    left: 0;
    bottom: -11px;
  }

  & > .newsMoreBtn {
    position: absolute;
    right: 5px;
    top: -67px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 18px;
    color: #97a3c2;
    text-align: left;
    font-style: normal;
    display: flex;
    align-items: center;
    cursor: pointer;

    span {
      font-size: 12px;
      margin-left: 5px;
    }
  }
}

.infoBox {
  // transform: translate(0px, -36px);
  width: 100%;
  height: 704px;
  box-sizing: border-box;
  padding: 65px 160px 66px 160px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  & > div {
    width: 48%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;

    & > .newsMoreBtn {
      position: absolute;
      right: 5px;
      top: 38px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 18px;
      color: #97a3c2;
      text-align: left;
      font-style: normal;
      display: flex;
      align-items: center;
      cursor: pointer;

      span {
        font-size: 12px;
        margin-left: 5px;
      }
    }
  }

  & > div:nth-child(2) {
    width: 45%;
    // height: 693px;
    height: 100%;
    box-sizing: border-box;

    .cardBox {
      width: 100%;
      height: 25%;
      padding: 20px 38px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #f2f2f2;
      box-sizing: border-box;

      .imgBox {
        width: 101px;
        height: 70px;
        border-radius: 10px;
        overflow: hidden;

        img {
          height: 70px;
          width: auto;
        }
      }

      .wordBox {
        margin-left: 58px;
      }

      div {
        p {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 20px;
          color: #333333;
          line-height: 28px;
          text-align: left;
          font-style: normal;
          margin-bottom: 15px;
          max-width: 130px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        div {
          width: 50px;
          display: flex;
          align-items: center;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #97a3c2;
          line-height: 22px;
          text-align: left;
          font-style: normal;
          cursor: pointer;

          span {
            font-size: 14px;
            margin-left: 7px;
          }
        }
      }
    }

    .cardBox:last-child {
      border: none !important;
    }
  }

  .infoTitle {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 38px;
    color: #242b3c;
    line-height: 67px;
    text-align: left;
    font-style: normal;
    margin-bottom: 25px;
  }

  .sameBox {
    ul {
      height: calc(100% - 92px);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;

      li {
        width: 100%;
        cursor: pointer;

        & > .smallBox {
          position: relative;
          display: flex;
          align-items: center;
          padding: 10px 0px;
          border-bottom: 1px solid #ededed;

          span {
            position: absolute;
            right: 0px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 13px;
            color: #999999;
            line-height: 20px;
            text-align: justify;
            font-style: normal;
            margin-right: 6px;
            width: 80px;
          }

          p {
            width: calc(100% - 126px);
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: #333333;
            line-height: 25px;
            text-align: left;
            font-style: normal;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        & > .bigBox {
          width: 100%;
          height: 176px;
          background: #006ab1;
          border-radius: 10px;
          display: flex;
          align-items: center;
          box-sizing: border-box;
          padding-right: 24px;

          & > img {
            width: 164px;
            height: 115px;
            margin-right: 21px;
            margin-left: 24px;
          }

          div {
            display: flex;
            flex-direction: column;

            span {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 13px;
              color: #84a0e2;
              line-height: 20px;
              text-align: justify;
              font-style: normal;
              margin-bottom: 5px;
            }

            p {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 18px;
              color: #ffffff;
              line-height: 25px;
              text-align: left;
              font-style: normal;
              height: 78px;
              overflow: hidden;
              /* 确保内容超出容器时会被裁剪 */
              display: -webkit-box;
              /* 使用弹性盒子布局模型 */
              -webkit-line-clamp: 3;
              /* 限制在3行 */
              -webkit-box-orient: vertical;
              /* 垂直排列盒子 */
              text-overflow: ellipsis;
              /* 多行时显示省略符号 */
              white-space: normal;
              /* 使用正常的白空格处理方式，允许换行 */
              margin-bottom: 5px;
            }

            img {
              width: 20px;
              height: 11px;
            }
          }
        }
      }
    }
  }
}

.addressBox {
  width: 100%;
  height: 437px;
  background: #f9f9f9;
  box-sizing: border-box;
  padding: 80px 8%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  // transform: translate(0px, -72px);
  .mapBox {
    width: 57.6%;
    height: 100%;
    box-sizing: border-box;
    border: 1px solid #cbc9c9;
  }

  .worldBox {
    height: 100%;
    width: 40%;

    .title {
      font-family: SourceHanSansCN, SourceHanSansCN;
      font-weight: bold;
      font-size: 30px;
      color: #333333;
      line-height: 54px;
      text-align: left;
      font-style: normal;
      margin-bottom: 28px;
    }

    p {
      font-family: SourceHanSansCN, SourceHanSansCN;
      font-weight: 400;
      font-size: 18px;
      color: #333333;
      line-height: 30px;
      text-align: left;
      font-style: normal;
      margin-bottom: 10px;
    }
  }
}

.bkywBox {
  width: 100%;
  height: 88.52vh;
  background: url("~@/assets/home/bkyw.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-wrap: wrap;

  & > div {
    width: 25%;
    height: 50%;
    background: rgba(6, 33, 88, 0.5);
    box-sizing: border-box;
    padding: 5.23vh 2.5vw;
    position: relative;
    border-right: 1px solid #475a7c;
    border-bottom: 1px solid #475a7c;

    p {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      // font-size: 36px;
      font-size: 1.875vw;
      color: #ffffff;
      // line-height: 56px;
      text-align: justify;
      font-style: normal;
    }

    .content {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 0.833vw;
      color: #ffffff;
      line-height: 30px;
      text-align: left;
      font-style: normal;
      margin-top: 1vw;
      height: 120px;
      // overflow-y: scroll;
      // overflow-x: hidden;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
    }

    .moreBox {
      display: flex;
      align-items: center;
      position: absolute;
      bottom: 5.23vh;

      span {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 15px;
        color: #ffffff;
        line-height: 22px;
        text-align: left;
        font-style: normal;
        cursor: pointer;
      }

      img {
        width: 19px;
        height: 11px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 76px;
        cursor: pointer;
      }

      .moveImg {
        animation: moveRight 0.78s linear infinite;
      }
    }
  }

  & > div:nth-child(4) {
    border-right: none;
  }

  & > div:nth-child(5) {
    border-bottom: none;
  }

  & > div:nth-child(6) {
    border-bottom: none;
  }

  & > div:nth-child(7) {
    border-bottom: none;
  }

  & > div:nth-child(8) {
    border-bottom: none;
    border-right: none;
  }

  & > .totalBox {
    p {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 2.29vw;
      color: #ffffff;
      // line-height: 67px;
      text-align: left;
      font-style: normal;
    }

    div {
      width: 10.42vw;
      height: 3.125vw;
      background: #ffffff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 0 12px 0 15px;
      border-radius: 29px;
      margin-top: 4vw;

      span {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 0.83vw;
        color: #0069b0;
        // line-height: 25px;
        text-align: center;
        font-style: normal;
      }

      img {
        width: 2.08vw;
        height: 2.08vw;
        // width: 2.5rem;
        // height: 2.5rem;
        cursor: pointer;
      }
    }
  }

  & > .blueBg {
    background: rgba(3, 67, 156, 0.76);
  }
}

.bkywBg0 {
  background: url("~@/assets/home/bkywBg0.png") no-repeat;
  background-size: 100% 100%;
}

.bkywBg1 {
  background: url("~@/assets/home/bkywBg1.png") no-repeat;
  background-size: 100% 100%;
}

.bkywBg2 {
  background: url("~@/assets/home/bkywBg2.png") no-repeat;
  background-size: 100% 100%;
}

.bkywBg3 {
  background: url("~@/assets/home/bkywBg3.png") no-repeat;
  background-size: 100% 100%;
}

.bkywBg4 {
  background: url("~@/assets/home/bkywBg4.png") no-repeat;
  background-size: 100% 100%;
}

.bkywBg5 {
  background: url("~@/assets/home/bkywBg5.png") no-repeat;
  background-size: 100% 100%;
}

.bkywBg6 {
  background: url("~@/assets/home/bkywBg6.png") no-repeat;
  background-size: 100% 100%;
}

@keyframes moveRight {
  0% {
    left: 76px;
  }

  50% {
    left: 85px;
  }

  100% {
    left: 76px;
  }
}
</style>
